<template>
  <pt-goods-review class="pt-goods-review__page"></pt-goods-review>
</template>

<script>
import PtGoodsReview from 'cps/mall-manage/pt-goods-review/withData'
export default {
  name: 'pt-goods-review__view',
  components: {
    'pt-goods-review': PtGoodsReview
  }
}
</script>
